import { Component, input, output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { FormArrayContextParameters } from '../models/FormModels';

@Component({
  selector: 'app-voucher-atp-parameters',
  templateUrl: './voucher-atp-parameters.component.html',
  styleUrls: ['./voucher-atp-parameters.component.scss'],
  standalone: false
})
export class VoucherAtpParametersComponent {
  title = input<string>('');
  type = input<'secureParameters' | 'parameters'>('parameters');
  formArray = input<FormArray<FormGroup<FormArrayContextParameters>>>(new FormArray<FormGroup<FormArrayContextParameters>>([]));
  canModify = input.required<boolean>();

  addParameters = output<FormArray<FormGroup<FormArrayContextParameters>>>();
}
